// src/pages/sis/StudentCOR.js
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { mockStudents } from "../../data/mockStudents";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const handleDownloadPDF = async () => {
  const element = document.getElementById("cor-container");
  const canvas = await html2canvas(element);
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const imgProps = pdf.getImageProperties(imgData);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("Certificate_of_Registration.pdf");
};

const StudentCOR = () => {
  const { id } = useParams();

  const student = useMemo(() => {
    return mockStudents.find((s) => String(s.id) === String(id));
  }, [id]);

  const subjects = student?.subjects || [];

  const campusHeader = useMemo(() => {
    const campus = (student?.campus || "").toLowerCase();
    if (campus === "gapan" || campus.includes("ne") || campus.includes("nueva")) {
      return (
        <>
          <h2 className="font-bold text-lg">VILLAGE MONTESSORI SCHOOL (Gapan, Nueva Ecija), Inc.</h2>
          <p>Consuelo Subdivision, Bayanihan, Gapan City, Nueva Ecija</p>
          <p>Tel. No. (044) 331 3945</p>
        </>
      );
    }
    return (
      <>
        <h2 className="font-bold text-lg">VILLAGE MONTESSORI SCHOOL (Bulacan), Inc.</h2>
        <p>Phase D, Block 1, Lot 1, Francisco Homes, San Jose del Monte, Philippines</p>
        <p>Tel. No. 0939 180 6909</p>
      </>
    );
  }, [student]);

  const issuedDate = useMemo(() => new Date().toLocaleDateString(), []);
  const schoolYear = useMemo(() => {
    const year = new Date().getFullYear();
    return `${year}-${year + 1}`;
  }, []);

  if (!student) {
    return <div className="alert alert-warning">Student not found.</div>;
  }

  return (
    <div id="cor-container" className="p-10 bg-white text-black text-sm" style={{ width: "210mm", minHeight: "297mm", margin: "auto" }}>
      <div className="text-center mb-4">
        {campusHeader}
        <h3 className="font-semibold mt-2">School Year: {schoolYear}</h3>
        <h1 className="text-xl font-bold mt-4 underline">CERTIFICATE OF REGISTRATION</h1>
      </div>

      <div className="border border-black p-3 mb-4">
        <p><strong>Student Name:</strong> {student.fullname || student.name}</p>
        <p><strong>Student No.:</strong> {student.lrn || student.id}</p>
        <p><strong>Grade & Section:</strong> {student.gradeLevel} {student.section ? `- ${student.section}` : ""}</p>
        <p><strong>Campus:</strong> {student.campus}</p>
        <p><strong>Date Issued:</strong> {issuedDate}</p>
      </div>

      <table className="w-full border border-black mb-4 text-sm">
        <thead>
          <tr className="bg-gray-100 border-b border-black">
            <th className="border border-black p-1">Code</th>
            <th className="border border-black p-1">Subject Title</th>
            <th className="border border-black p-1">Teacher</th>
          </tr>
        </thead>
        <tbody>
          {subjects.map((subj, index) => (
            <tr key={index}>
              <td className="border border-black p-1">{subj.code}</td>
              <td className="border border-black p-1">{subj.name || subj.title}</td>
              <td className="border border-black p-1">{subj.teacher || ""}</td>
            </tr>
          ))}
          {subjects.length === 0 && (
            <tr>
              <td className="border border-black p-1" colSpan="3">No subjects assigned</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="flex justify-end gap-4 mt-8">
        <button
          onClick={() => window.print()}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
        >
          Print COR
        </button>

        <button
          onClick={handleDownloadPDF}
          className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
        >
          Download COR (PDF)
        </button>
        <a
          href="/sis/students"
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Back to Students
        </a>
      </div>
    </div>
  );
};

export default StudentCOR;
